import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['fileInput', 'filesCount', 'filesCountText']

  connect() {
    if (this.hasFilesCountTextTarget) {
      this.photoChanged = this.photoChanged.bind(this)
      this.fileInputTarget.addEventListener('change', this.photoChanged)
    }
  }

  photoChanged(event) {
    const count = event.target.files.length
    this.filesCountTextTarget.classList.remove('d-none')
    this.filesCountTarget.innerText = count == 1 ? `1 image` : `${count} images`

  }

  openFileInput() {
    this.fileInputTarget.click()
  }

  submitForm() {
    this.fileInputTarget.form.submit()
  }
}
